import React from "react";
import MainLayout from "./MainLayout";
import SavedSearches from "../common/MainContent/SavedSearches/SavedSearches";

const SavedSearchesPage = (props) => <MainLayout component={SavedSearches} />;

export default SavedSearchesPage;
